import { useTranslation } from "react-i18next";
import { Flame, ThermometerSun, Thermometer, Snowflake } from "lucide-react";

const TIER_CONFIG = {
  hot:   { Icon: Flame,          cls: "border-red-400/60 text-red-600 dark:text-red-400 bg-red-500/5",            label: "Hot" },
  warm:  { Icon: ThermometerSun, cls: "border-emerald-400/60 text-emerald-600 dark:text-emerald-400 bg-emerald-500/5", label: "Warm" },
  tepid: { Icon: Thermometer,    cls: "border-amber-400/60 text-amber-600 dark:text-amber-400 bg-amber-500/5",    label: "Tepid" },
  cold:  { Icon: Snowflake,      cls: "border-slate-400/60 text-slate-500 dark:text-slate-400 bg-slate-500/5",    label: "Cold" },
};

export default function EngagementScoreBadge({ score = 0, tier = "COLD", size = "sm", showLabel = false }) {
  const { t } = useTranslation();
  // Normalize tier to lowercase for the internal config lookup (accepts both 'HOT' and 'hot' from DB)
  const tierKey = String(tier || "cold").toLowerCase();
  const cfg = TIER_CONFIG[tierKey] || TIER_CONFIG.cold;
  const { Icon } = cfg;
  const sizes = {
    xs: "h-4 px-1.5 text-[9px] gap-0.5",
    sm: "h-5 px-1.5 text-[10px] gap-1",
    md: "h-6 px-2 text-xs gap-1",
  };
  const iconSize = { xs: "h-2.5 w-2.5", sm: "h-3 w-3", md: "h-3.5 w-3.5" };
  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold tabular-nums ${cfg.cls} ${sizes[size] || sizes.sm}`}
      title={t(`contacts.tier_${tierKey}`) || cfg.label}
      data-testid={`engagement-score-${score}`}
    >
      <Icon className={iconSize[size] || iconSize.sm} />
      {score}
      {showLabel && <span className="ml-0.5">{t(`contacts.tier_${tierKey}`) || cfg.label}</span>}
    </span>
  );
}
